import axios from 'axios';
import {DbPathHelper} from "./DBPaths";

const dynamicHeaders = {
  'ClientId': localStorage.getItem('client_id') || '',
  'TimezoneOffset': new Date().getTimezoneOffset()
};

class ApiService {
  constructor() {
    if (!ApiService.instance) {

      this.api = axios.create({
        baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5132/api',
        withCredentials: true,
      });

      this._setupInterceptors();
      ApiService.instance = this;
    }

    return ApiService.instance;
  }

  _setupInterceptors() {
    this.api.interceptors.request.use(
      config => {
        const token = localStorage.getItem('access_token') || '';

        if (token) {
          config.headers.Authorization = `Bearer ${token ? token.slice(1, -1) : ''}`;
        }

        return config;
      },
      error => Promise.reject(error)
    );

    this.api.interceptors.response.use(
        response => response,
        error => {
          if (error.response && error.response.status === 401) {
            // store.dispatch(logout());

            if (error.response?.config?.url === DbPathHelper.getLoginPath()) {
                return;
            }

            // window.location.href = '/sign-in';
          }


          return Promise.reject(error);
        }
    );
  }

  get(url, config = {}) {
    const mergedHeaders = { ...dynamicHeaders, ...(config || {}), 'ClientId': localStorage.getItem('client_id') || '' };

    return this.api.get(url, { ...config, headers: mergedHeaders });
  }

  post(url, data, config = {}) {
    const mergedHeaders = { ...dynamicHeaders, ...(config || {}), 'ClientId': localStorage.getItem('client_id') || '' };

    return this.api.post(url, data, { ...config, headers: mergedHeaders });
  }

  put(url, data, config = {}) {
    const mergedHeaders = { ...dynamicHeaders, ...(config || {}), 'ClientId': localStorage.getItem('client_id') || '' };

    return this.api.put(url, data, { ...config, headers: mergedHeaders });
  }

  delete(url, config = {}) {
    const mergedHeaders = { ...dynamicHeaders, ...(config || {}), 'ClientId': localStorage.getItem('client_id') || '' };

    return this.api.put(url, { ...config, headers: mergedHeaders });
  }
}

const Http = new ApiService();
Object.freeze(Http);

export {Http};
